import { makeAppInstance, warningBanner } from '@zg-rentals/util';
import pino from 'pino';

export type Logger = pino.Logger;

export type LoggerOptions = pino.LoggerOptions & {
  logPath?: string;
};

export const createLogger = pino;

const { get, set: setGlobalLogger } = makeAppInstance<Logger | undefined>(
  () => undefined,
  '@zg-rentals/logger-base:logger',
);

export function getGlobalLogger(name?: string) {
  return name ? get()?.child({ name }) : get();
}

export { setGlobalLogger, warningBanner };
